import React from 'react'
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs'
import WrapperSection from '../../components/global/WrapperSection'
import FormAddEditRoles from '../../components/Roles/FormAddEditRoles'

const CreateRoles = () => {
  return (
    <>
      <WrapperSection>
        <GlobalBreadcrumbs />
        <FormAddEditRoles />
      </WrapperSection>
    </>
  )
}

export default CreateRoles